import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import useQuery from "../utils/useQuery";
import { axiosPrivate, axiosQuick } from "../api/axios";
import "../assets/scss/components/dashboard.scss";
import Header from "../components/shared/header";
import { Badge } from "primereact/badge";
import moment from "moment";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import CreateQuery from "../containers/createQuery";
import { categoryList } from "../data/categories";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";

import loader from "../utils/Helper";
import { Grid, Button, Chip, Tooltip, CircularProgress } from "@mui/material";
import _ from "lodash";
import { ProgressSpinner } from "primereact/progressspinner";

const token = localStorage.getItem("jwtToken");

const GET_ALL_QUERY = "/getAllQueries";
const DELETE_QUERY_BY_QUERY_ID = "/deleteQuery";
const GET_USERS = "/getAllUsersForDashboard";

const Dashboard = () => {
  const dataTableRef = useRef(null);
  const userData = JSON.parse(localStorage.getItem("user"));
  const IS_ADMIN = userData?.isAdmin || false;
  const loggedinuserid = userData?.id || 0;
  const IS_SUPERADMIN = userData?.isSuperAdmin || false;
  console.log("userData", userData);
  const { setQueryData } = useQuery();
  const [query, setQuery] = useState(null);
  const [chartData, setChartData] = useState({});
  const [displayResponsive, setDisplayResponsive] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [assignedToOptions, setAssignedToOptions] = useState(null);
  const [departmentFilter, setDepartmentFilter] = useState(null);
  const [userFilter, setUserFilter] = useState(null);
  const [statusFilter, setStatusFilter] = useState(null);
  const [searchFilter, setsearchFilter] = useState("");
  const [priorityFilter, setPriorityFilter] = useState(null);
  const [selectedExportQuery, setselectedExportQuery] = useState([]);
  const [filtersLoaded, setFiltersLoaded] = useState(false);

  const [fileITR, setFileITR] = useState(false);
  const [exportRunning, setexportRunning] = useState(false);

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      setexportRunning(true);
      loader.isLoading(true);
      const CustomHeadersKeys = {
        assignedTo: "Assigned Consultant",
        companyName: "Company Name",
        createdOn: "Created On",
        dueDate: "Due Date",
        financialYear: "Financial Year",
        priority: "Priority",
        remarks: "Remarks",
        section: "Section",
        status: "Status",
        subject: "Subject",
        userName: "Username",
        assesseeName: "Assessee Name",
        referredBy: "Referred By",
        blockAssessment: "Block Assessment",
        start: "Start Date",
        end: "End Date",
        modifiedOn: "Modified On",
      };
      const keysToRemove = [
        "id",
        "usersId",
        "categoryId",
        "assignedUserId",
        "unread",
        "comments",
        "documents",
        "deleted",
        "feesDetails",
        "consultingTeam",
        "consultingTeamNames",
        "internalComments",
        "internalDocuments",
        "priority",
      ];

      const exportColumns = [
        "userName",
        "companyName",
        "subject",
        "section",
        "financialYear",
        "blockAssessment",
        "start",
        "end",
        "assesseeName",
        "referredBy",
        "assignedTo",
        "dueDate",
        "createdOn",
        "modifiedOn",
        "status",
        "remarks",
      ];

      const export_item =
        selectedExportQuery.length > 0 ? selectedExportQuery : tableData;
      // Iterate over the export_item array and transform the data with custom headers
      const selectedTabledata = export_item.map((obj) => {
        const row = {};

        exportColumns.forEach((key) => {
          let value = obj[key];

          if (key === "blockAssessment") {
            value = value ? "Yes" : "No";
          }

          row[CustomHeadersKeys[key] || key] = value;
        });

        return row;
      });

      const worksheet = xlsx.utils.json_to_sheet(selectedTabledata);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "Queries");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver")
      .then((module) => {
        if (module && module.default) {
          let EXCEL_TYPE =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          let EXCEL_EXTENSION = ".xlsx";
          const data = new Blob([buffer], {
            type: EXCEL_TYPE,
          });

          module.default.saveAs(
            data,
            fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
          );
        }
        setexportRunning(false);
        loader.isLoading(false);
      })
      .catch((err) => {
        setexportRunning(false);
      });
  };

  const getData = async () => {
    try {
      loader.isLoading(true);
      var allusers = assignedToOptions ?? (await getUsers());
      loader.isLoading(true);
      const response = await axiosQuick.get(`${GET_ALL_QUERY}/${userData.id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userData.jwtToken}`,
        },
      });

      if (response.status === 200) {
        setQuery(response?.data?.queries);
        var responsequeries = response?.data?.queries;
        const savedRaw = localStorage.getItem("dashboardFilters");
        if (!savedRaw) {
          setFiltersLoaded(true);
          loader.isLoading(false);
          getUsers();
          return;
        }
        const saved = JSON.parse(savedRaw);
        let users = allusers;

        // Map saved IDs/codes back to full objects
        const dept = categoryList.find(
          (d) => d.id === saved.departmentFilter?.id
        );
        const user = users?.find(
          (u) => String(u.code) === String(saved.userFilter)
        );
        const status = statusOptions.find(
          (s) => s.code === saved.statusFilter?.code
        );
        const priority = priorityOptions.find(
          (p) => p.code === saved.priorityFilter?.code
        );

        if (dept) {
          responsequeries = responsequeries.filter(
            (a) => a.categoryId == dept.id
          );
        }
        if (user) {
          responsequeries = responsequeries.filter(
            (a) => String(a.assignedUserId) === String(user.code)
          );
        }
        if (status) {
          responsequeries = responsequeries.filter(
            (a) => a.status == status.code
          );
        }
        if (priority) {
          responsequeries = responsequeries.filter(
            (a) => a.priority == priority.code
          );
        }
        if (saved.searchFilter) {
          responsequeries = handleSearch(responsequeries, saved.searchFilter);
        }

        setTableData(responsequeries);
        initiatiefilters(allusers);
        var chartDataSet = {
          labels: ["New", "Resolved"],
          datasets: [
            {
              data: [],
              backgroundColor: ["#FF6384", "#FFCE56"],
              hoverBackgroundColor: ["#FF6384", "#FFCE56"],
            },
          ],
        };
        chartDataSet.datasets[0].data.push(response.data.openCount);
        chartDataSet.datasets[0].data.push(response.data.resolvedCount);
        setChartData(chartDataSet);
      }
      let id;
      if (query) {
        query?.queries?.map((singleItem, index) => {
          id = singleItem.id;
        });
        setQueryData({
          id: id,
        });
      }
      loader.isLoading(false);
    } catch (err) {
      loader.isLoading(false);
    }
  };

  const getUsers = async () => {
    loader.isLoading(true);
    const response = await axiosPrivate.get(`${GET_USERS}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userData.jwtToken}`,
      },
    });
    const resultUsers = [];
    if (response.status === 200 && response?.data) {
      var row = {
        name: "No Consultant Selected",
        code: 0,
      };
      resultUsers.push(row);
      response?.data?.map((a) => {
        var row = {
          name: a.referenceName + " (" + a.email + ")",
          code: a.id,
        };
        resultUsers.push(row);
      });

      setAssignedToOptions(resultUsers);
    }

    loader.isLoading(false);
    return resultUsers;
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [
    departmentFilter,
    userFilter,
    statusFilter,
    priorityFilter,
    searchFilter,
  ]);

  // useEffect(() => {
  //   if (!assignedToOptions) return;

  //   const savedFilters = JSON.parse(localStorage.getItem("dashboardFilters"));

  //   if (savedFilters) {
  //     const user = assignedToOptions.find(
  //       (u) => String(u.code) === String(savedFilters.userFilter)
  //     );

  //     setUserFilter(user || null);
  //   }

  //   setFiltersLoaded(true);
  // }, [assignedToOptions]);

  // 1. SINGLE INITIALIZATION EFFECT
  const initiatiefilters = (allusers) => {
    const savedRaw = localStorage.getItem("dashboardFilters");
    if (!savedRaw) {
      setFiltersLoaded(true);
      return;
    }

    const saved = JSON.parse(savedRaw);
    let users = allusers;

    // Map saved IDs/codes back to full objects
    const dept = categoryList.find((d) => d.id === saved.departmentFilter?.id);
    const user = users?.find(
      (u) => String(u.code) === String(saved.userFilter)
    );
    const status = statusOptions.find(
      (s) => s.code === saved.statusFilter?.code
    );
    const priority = priorityOptions.find(
      (p) => p.code === saved.priorityFilter?.code
    );

    // Batch updates (React 18+ handles this automatically)
    setDepartmentFilter(dept || null);
    setUserFilter(user || null);
    setStatusFilter(status || null);
    setPriorityFilter(priority || null);
    setsearchFilter(saved.searchFilter || "");

    // ONLY set this true once everything above is finished
    setFiltersLoaded(true);
  };

  // useEffect(() => {
  //   const init = async () => {
  //     const savedRaw = localStorage.getItem("dashboardFilters");
  //     if (!savedRaw) {
  //       setFiltersLoaded(true);
  //       return;
  //     }

  //     const saved = JSON.parse(savedRaw);
  //     let users = assignedToOptions;

  //     // Fetch users if missing
  //     if (!users) {
  //       users = await getUsers();
  //     }

  //     // Map saved IDs/codes back to full objects
  //     const dept = categoryList.find(d => d.id === saved.departmentFilter?.id);
  //     const user = users?.find(u => String(u.code) === String(saved.userFilter));
  //     const status = statusOptions.find(s => s.code === saved.statusFilter?.code);
  //     const priority = priorityOptions.find(p => p.code === saved.priorityFilter?.code);

  //     // Batch updates (React 18+ handles this automatically)
  //     setDepartmentFilter(dept || null);
  //     setUserFilter(user || null);
  //     setStatusFilter(status || null);
  //     setPriorityFilter(priority || null);
  //     setsearchFilter(saved.searchFilter || "");

  //     // ONLY set this true once everything above is finished
  //     setFiltersLoaded(true);
  //   };

  //   init();
  //   // Empty dependency array ensures this ONLY runs on mount
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // 2. APPLY FILTERS (Watch the filter states)
  useEffect(() => {
    if (filtersLoaded) {
      applyFilters();
    }
  }, [
    filtersLoaded,
    departmentFilter,
    userFilter,
    statusFilter,
    priorityFilter,
    searchFilter,
  ]);

  // 3. PERSIST TO LOCALSTORAGE
  useEffect(() => {
    // Only save if initialization is complete to avoid wiping storage with defaults
    if (!filtersLoaded) return;

    const filtersToSave = {
      departmentFilter,
      userFilter: userFilter?.code || null, // Save the code/ID only
      statusFilter,
      priorityFilter,
      searchFilter,
    };

    localStorage.setItem("dashboardFilters", JSON.stringify(filtersToSave));
  }, [
    filtersLoaded,
    departmentFilter,
    userFilter,
    statusFilter,
    priorityFilter,
    searchFilter,
  ]);

  const handleDelete = (event) => {
    const itemId = event.currentTarget.id;
    const deleteItem = async () => {
      const response = await axiosPrivate.delete(
        `${DELETE_QUERY_BY_QUERY_ID}/${itemId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData.jwtToken}`,
          },
        }
      );
      if (response.status === 200) {
        getData();
      }
    };

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteItem();
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Your query has been deleted",
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });
  };

  const actionsBodyTemplate = (rowData) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexWrap: "nowrap",
        whiteSpace: "nowrap",
        gap: "8px",
      }}
    >
      <Link to={`/query-details/${rowData.id}`}>
        <i title="Details" className="fa-solid fa-eye"></i>
      </Link>

      {!userData.isAdmin &&
        !userData.isSuperAdmin &&
        rowData.status === "New" && (
          <i
            title="Delete"
            id={rowData.id}
            onClick={handleDelete}
            className="fa-solid fa-trash-can text-danger"
            style={{ cursor: "pointer" }}
          />
        )}

    {rowData.unread &&
      <Badge
        value=""
        style={{ backgroundColor: "black", flexShrink: 0 }}
      />
    }
    </div>
  );
};

  const createdOnBodyTemplate = (rowData) => {
    const formattedDate = moment
      .utc(rowData.createdOn)
      .local()
      .format("MMMM DD, YYYY");

    return (
      <span style={{ fontWeight: rowData.unread ? "bold" : "normal" }}>
        {formattedDate}
      </span>
    );
  };

  const blockAssessmentBodyTemplate = (rowData) => {
    return (
      <span style={{ fontWeight: rowData.unread ? "bold" : "normal" }}>
        {rowData.blockAssessment ? "Yes" : "No"}
      </span>
    );
  };

  const startBodyTemplate = (rowData) => {
    const formattedDate = rowData.start
      ? moment(rowData.start).format("MMMM DD, YYYY")
      : "";

    return (
      <span style={{ fontWeight: rowData.unread ? "bold" : "normal" }}>
        {formattedDate}
      </span>
    );
  };

  const endBodyTemplate = (rowData) => {
    const formattedDate = rowData.end
      ? moment(rowData.end).format("MMMM DD, YYYY")
      : "";

    return (
      <span style={{ fontWeight: rowData.unread ? "bold" : "normal" }}>
        {formattedDate}
      </span>
    );
  };

  const dueDateBodyTemplate = (rowData) => {
    const customStyle = userData.isSuperAdmin
      ? rowClass(rowData)
      : userData.isAdmin
      ? rowClass(rowData)
      : {};
    return rowData.dueDate ? (
      <Chip
        variant="filled"
        style={customStyle} // Apply the custom style object here
        label={moment.utc(rowData.dueDate).local().format("MMMM DD, YYYY")}
      ></Chip>
    ) : null;
  };

  const statusBodyTemplate = (rowData) => {
    return <Badge value={rowData.status}></Badge>;
  };

  const remarksBodyTemplate = (rowData) => {
    return (
      <>
        {rowData.remarks ? (
          <Tooltip title={rowData.remarks} placement="bottom">
            <span
              className="remarksSpan"
              style={{ fontWeight: rowData.unread ? "bold" : "normal" }}
            >
              {rowData.remarks.substring(0, 25)}
              {rowData.remarks.length > 25 && "..."}
            </span>
          </Tooltip>
        ) : null}
      </>
    );
  };

  const categoryBodyTemplate = (rowData) => {
    const category = categoryList.find(
      (a) => a.id == rowData.categoryId
    )?.category;

    return (
      <span style={{ fontWeight: rowData.unread ? "bold" : "normal" }}>
        {category}
      </span>
    );
  };

  const rowClass = (data) => {
    if (!data.dueDate) {
      return {};
    }

    const dueDate = new Date(data.dueDate);
    const currentDate = new Date();
    const daysUntilDue = Math.floor(
      (dueDate - currentDate) / (1000 * 60 * 60 * 24)
    );

    if (daysUntilDue < 0) {
      return {
        backgroundColor: "#742143",
        color: "#EBEBEB",
      };
    } else if (daysUntilDue <= 3) {
      return {
        backgroundColor: "#dc476b",
        color: "#EBEBEB",
      };
    } else if (daysUntilDue <= 7) {
      return {
        backgroundColor: "#ff7891",
        color: "#EBEBEB",
      };
    } else {
      return {
        backgroundColor: "#EBEBEB",
        color: "#000000",
      };
    }
  };

  const statusOptions = [
    { name: "New", code: "New" },
    { name: "In Progress", code: "In Progress" },
    { name: "Resolved", code: "Resolved" },
  ];

  const priorityOptions = [
    { name: "High", code: "High" },
    { name: "Medium", code: "Medium" },
    { name: "Low", code: "Low" },
  ];

  const handleSearch = (filteredData, searchValue) => {
    filteredData = filteredData.filter((a) => {
      const isMatch =
        a.financialYear?.toLowerCase().includes(searchValue) ||
        a.assesseeName?.toLowerCase().includes(searchValue) ||
        a.userName?.toLowerCase().includes(searchValue) ||
        a.subject?.toLowerCase().includes(searchValue);

      if (userData.isSuperAdmin) {
        return (
          isMatch &&
          (!departmentFilter || a.categoryId == departmentFilter.id) &&
          (!userFilter || a.assignedUserId == userFilter.code) &&
          (!statusFilter || a.status == statusFilter.code) &&
          (!priorityFilter || a.priority == priorityFilter.code)
        );
      } else if (userData.isAdmin) {
        return isMatch;
      } else {
        return isMatch;
      }
    });
    return filteredData;
  };

  const applyFilters = () => {
    let filteredData = query ? [...query] : []; // Create a copy of the original data

    // Apply filters one by one
    if (departmentFilter) {
      filteredData = filteredData.filter(
        (a) => a.categoryId == departmentFilter.id
      );
    }
    if (userFilter) {
      filteredData = filteredData.filter(
        (a) => String(a.assignedUserId) === String(userFilter.code)
      );
    }
    if (statusFilter) {
      filteredData = filteredData.filter((a) => a.status == statusFilter.code);
    }
    if (priorityFilter) {
      filteredData = filteredData.filter(
        (a) => a.priority == priorityFilter.code
      );
    }
    if (searchFilter) {
      filteredData = handleSearch(filteredData, searchFilter);
    }

    // Set the filtered data
    setTableData(filteredData);
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem("isReload", "true");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    if (sessionStorage.getItem("isReload") === "true") {
      sessionStorage.removeItem("isReload");
      setDepartmentFilter(null);
      setUserFilter(null);
      setStatusFilter(null);
      setPriorityFilter(null);
      setsearchFilter("");
      localStorage.removeItem("dashboardFilters");
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <div style={{ backgroundColor: "white" }}>
      <Header />

      <Dialog
        header={fileITR ? "File ITR" : "Create Query"}
        visible={displayResponsive}
        onHide={() => setDisplayResponsive(false)}
        className="dialogSize"
        position="right"
      >
        <CreateQuery
          fileITR={fileITR}
          isAdmin={IS_ADMIN}
          isSuperAdmin={IS_SUPERADMIN}
          loggedinuserid={loggedinuserid}
        />
      </Dialog>

      <div className="dashboard-area">

        {/* Superadmin */}
        {userData.isSuperAdmin &&(
        <div style={{marginTop : "10px", marginRight : "38px"}}>
                <div
                  className="btn-create-small submitbutton"
                  onClick={() => {
                    setDisplayResponsive(true);
                    setFileITR(false);
                  }}
                >
                  <i className="fa-solid fa-plus px-2" />
                  Create Query
                </div>

                <div
                  className="btn-create-small submitbutton"
                  onClick={!exportRunning ? exportExcel : undefined}
                >
                  {exportRunning ? (
                    <>
                      <i className="fa fa-file-excel-o" />
                      <CircularProgress size={15} sx={{ ml: 1 }} />
                    </>
                  ) : (
                    <>
                      <i className="fa fa-file-excel-o" />
                      {selectedExportQuery.length > 0
                        ? `Export ${selectedExportQuery.length}`
                        : "Export All"}
                    </>
                  )}
                </div>
          </div>
        )}

        {/* Consultant */}
         {userData.isAdmin &&(
        <div style={{marginTop : "10px", marginRight : "38px"}}>
                <div
                  className="btn-create-small submitbutton"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setDisplayResponsive(true);
                    setFileITR(true);
                  }}
                >
                  File ITR
                </div>

                <div
                  className="btn-create-small submitbutton"
                  onClick={() => {
                    setDisplayResponsive(true);
                    setFileITR(false);
                  }}
                >
                  <i className="fa-solid fa-plus px-2" />
                  Create Query
                </div>

                <div
                  className="btn-create-small submitbutton"
                  onClick={!exportRunning ? exportExcel : undefined}
                >
                  {exportRunning ? (
                    <>
                      <i className="fa fa-file-excel-o" />
                      <CircularProgress size={15} sx={{ ml: 1 }} />
                    </>
                  ) : (
                    <>
                      <i className="fa fa-file-excel-o" />
                      {selectedExportQuery.length > 0
                        ? `Export ${selectedExportQuery.length}`
                        : "Export All"}
                    </>
                  )}
                </div>
          </div>
        )}
        
        {/* Filters */}
        {(userData.isSuperAdmin || userData.isAdmin) && (
          <div>
            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{
                mt: 2,
                flexWrap: {
                  xs: "wrap",
                  lg: "nowrap",
                },
              }}
            >
              {/* Department */}
              <Grid
                item
                xs={8}
                sm={6}
                md="auto"
                sx={{ minWidth: 220, flex: 1 }}
              >
                <Dropdown
                  showClear
                  value={departmentFilter}
                  options={categoryList}
                  optionLabel="category"
                  filter
                  resetFilterOnHide
                  filterBy="category"
                  placeholder="Select a Department"
                  onChange={(e) => setDepartmentFilter(e.value)}
                  style={{ width: "100%" }}
                />
              </Grid>

              {/* Consultant */}
              {userData.isSuperAdmin && (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md="auto"
                  sx={{ minWidth: 220, flex: 1 }}
                >
                  <Dropdown
                    showClear
                    value={userFilter}
                    options={assignedToOptions}
                    optionLabel="name"
                    filter
                    filterBy="name"
                    resetFilterOnHide
                    placeholder="Select a Consultant"
                    onChange={(e) => setUserFilter(e.value)}
                    style={{ width: "100%" }}
                  />
                </Grid>
              )}

              {/* Status */}
              <Grid item xs={6} sm={4} md="auto" sx={{ minWidth: 170 }}>
                <Dropdown
                  showClear
                  value={statusFilter}
                  options={statusOptions}
                  optionLabel="name"
                  placeholder="Select Status"
                  onChange={(e) => setStatusFilter(e.value)}
                  style={{ width: "100%" }}
                />
              </Grid>

              {/* Search */}
              <Grid item xs={12} md sx={{ minWidth: 200, flex: 2 }}>
                <span className="p-input-icon-left" style={{ width: "100%" }}>
                  <i className="pi pi-search" />
                  <InputText
                    value={searchFilter}
                    placeholder="Search by Username / Assessee / Subject"
                    onChange={(e) =>
                      setsearchFilter(e.target.value.toLowerCase())
                    }
                    style={{ width: "100%" }}
                  />
                </span>
              </Grid>

              {/* Clear */}
              <Grid item>
                <Tooltip title="Clear Filters" arrow>
                  <div
                    onClick={() => {
                      setDepartmentFilter(null);
                      setUserFilter(null);
                      setStatusFilter(null);
                      setPriorityFilter(null);
                      setsearchFilter("");
                    }}
                    style={{
                      width: 42,
                      height: 42,
                      borderRadius: "50%",
                      background: "#f5f5f5",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      flexShrink: 0,
                    }}
                  >
                    <i
                      className="pi pi-filter-slash"
                      style={{ fontSize: "1.3rem" }}
                    />
                  </div>
                </Tooltip>
              </Grid>

              {/* Buttons */}
              
            </Grid>
          </div>
        )}

        {/* Users */}
        {!userData.isSuperAdmin && !userData.isAdmin && (
          <div className="row" style={{ marginTop: "10px" }}>
              <div className="col-sm-12">
                <div
                  className="btn-create-small submitbutton"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setDisplayResponsive(true);
                    setFileITR(false);
                  }}
                >
                  <i title="Create Query" className="fa-solid fa-plus px-2"></i>
                  Create Query
                </div>
                <div
                  className="btn-create-small submitbutton"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setDisplayResponsive(true);
                    setFileITR(true);
                  }}
                >
                  File ITR
                </div>
              </div>
          </div>
        )}

        {query && (
          <Grid item xs={12}>
            <div className="add-scroll">
              <DataTable
                value={tableData}
                paginator
                rows={10}
                width={"100%"}
                ref={dataTableRef}
                selectionMode={
                  userData.isSuperAdmin
                    ? "checkbox"
                    : userData.isAdmin && "checkbox"
                }
                selection={
                  userData.isSuperAdmin
                    ? selectedExportQuery
                    : userData.isAdmin && selectedExportQuery
                }
                onSelectionChange={(e) =>
                  userData.isSuperAdmin
                    ? setselectedExportQuery(e.value)
                    : userData.isAdmin && setselectedExportQuery(e.value)
                }
                responsiveLayout="scroll"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                rowsPerPageOptions={[10, 20, 50]}
              >
                {/* <Column field="id" header="#" sortable></Column> */}
                {userData.isSuperAdmin ? (
                  <Column
                    selectionMode="multiple"
                    headerStyle={{ width: "3rem" }}
                  ></Column>
                ) : (
                  userData.isAdmin && (
                    <Column
                      selectionMode="multiple"
                      headerStyle={{ width: "3rem" }}
                    ></Column>
                  )
                )}
                <Column
  header="Actions"
  body={actionsBodyTemplate}
  style={{ width: "110px", minWidth: "110px" }}
  headerStyle={{ width: "110px", minWidth: "110px" }}
/>
                {/* <Column header="Actions" body={actionsBodyTemplate}></Column> */}
                <Column
                  field="userName"
                  header="Username"
                  style={{
                    display: userData.isSuperAdmin
                      ? ""
                      : userData.isAdmin
                      ? ""
                      : "none",
                  }}
                  body={(rowData) => (
                    <span
                      style={{ fontWeight: rowData.unread ? "bold" : "normal" }}
                    >
                      {rowData.userName}
                    </span>
                  )}
                  sortable
                ></Column>
                <Column
                  field="assesseeName"
                  header="Assessee Name"
                  // style={{
                  //   display:
                  //     userData.isSuperAdmin || userData.isAdmin ? "none" : "",
                  // }}
                  body={(rowData) => (
                    <span
                      style={{ fontWeight: rowData.unread ? "bold" : "normal" }}
                    >
                      {rowData.assesseeName}
                    </span>
                  )}
                  sortable
                ></Column>
                {/* <Column
                  field="companyName"
                  header="Company Name"
                  style={{
                    display: userData.isSuperAdmin
                      ? ""
                      : userData.isAdmin
                      ? ""
                      : "none",
                  }}
                  sortable
                ></Column> */}
                <Column
                  field="subject"
                  header="Subject"
                  body={(rowData) => (
                    <span
                      style={{ fontWeight: rowData.unread ? "bold" : "normal" }}
                    >
                      {rowData.subject}
                    </span>
                  )}
                  sortable
                ></Column>
                <Column
                  field="categoryId"
                  header="Section"
                  body={categoryBodyTemplate}
                  sortable
                ></Column>
                <Column
                  field="financialYear"
                  header="Financial Year"
                  body={(rowData) => (
                    <span
                      style={{ fontWeight: rowData.unread ? "bold" : "normal" }}
                    >
                      {rowData.financialYear}
                    </span>
                  )}
                  sortable
                ></Column>
                <Column
                  field="blockAssessment"
                  header="Block Assessment"
                  body={blockAssessmentBodyTemplate}
                  sortable
                ></Column>
                <Column
                  field="start"
                  header="Start Date"
                  body={startBodyTemplate}
                  sortable
                ></Column>
                <Column
                  field="end"
                  header="End Date"
                  body={endBodyTemplate}
                  sortable
                ></Column>
                <Column
                  field="assignedTo"
                  header="Assigned Consultant"
                  body={(rowData) => (
                    <span
                      style={{ fontWeight: rowData.unread ? "bold" : "normal" }}
                    >
                      {rowData.consultingTeam &&
                        rowData.consultingTeam.length > 0 && (
                          <Tooltip
                            title={
                              <div>
                                {rowData.consultingTeamNames?.map(
                                  (name, index) => (
                                    <div key={index}>{name}</div>
                                  )
                                )}
                              </div>
                            }
                            arrow
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  fontSize: "15px", // 👈 increase font size
                                  padding: "10px",
                                },
                              },
                            }}
                          >
                            <img
                              src={rowData.profileImage || "/group.jpg"}
                              alt="avatar"
                              style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                            />
                          </Tooltip>
                        )}
                      {rowData.assignedTo}
                    </span>
                  )}
                  sortable
                ></Column>
                <Column
                  field="dueDate"
                  header="Due Date"
                  body={dueDateBodyTemplate}
                  sortable
                ></Column>
                <Column
                  field="createdOn"
                  header="Created On"
                  body={createdOnBodyTemplate}
                  sortable
                ></Column>
                <Column
                  field="status"
                  header="Status"
                  body={statusBodyTemplate}
                  sortable
                ></Column>
                <Column
                  field="remarks"
                  header="Remarks"
                  body={remarksBodyTemplate}
                  style={{
                    display:
                      userData.isSuperAdmin || userData.isAdmin ? "" : "none",
                  }}
                  sortable
                ></Column>
              </DataTable>
            </div>
          </Grid>
        )}
      </div>
    </div>
  );
};
export default Dashboard;
